function faders() {
    function isElementInViewport(el) {
        let rect = el.getBoundingClientRect();

        return (
            (rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight)) //top in viewport
            || (rect.bottom >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) // bottom in viewport
            || (rect.top < 0 && rect.bottom > (window.innerHeight || document.documentElement.clientHeight)) //top above, bottom below viewport
        );
    }

    function elementsVisibility(classname) {
        let elements = document.querySelectorAll(`.${classname}:not(.${classname}-in-active)`);
        elements.forEach((el) => {
            if (isElementInViewport(el)) {
                if (classname === 'countup' && el.classList.contains('countup-active') === false) {
                    window.countUpAnimation(el);
                }
                el.classList.add(`${classname}-active`);
            }
        });
    }

    function onVisibilityChange() {
        elementsVisibility('countup');
        elementsVisibility('fade-in');
        elementsVisibility('scale-in');
        elementsVisibility('slide-in');
    }

    document.addEventListener('DOMContentLoaded', onVisibilityChange, false);
    document.addEventListener('load', onVisibilityChange, false);
    document.addEventListener('scroll', onVisibilityChange, false);
    document.addEventListener('resize', onVisibilityChange, false);
    onVisibilityChange();
}
faders();
